import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class FiCaptchaLoaderService {
    public ready: Observable<any>;
    public language = '';
    private static ready: BehaviorSubject<any>;

    constructor() {
        this.init();
        this.ready = FiCaptchaLoaderService.ready.asObservable();
    }

    public updateLanguage(newLang: string): void {
        this.language = newLang;
        FiCaptchaLoaderService.ready.next(null);
        this.init();
    }

    private init() {
        if (FiCaptchaLoaderService.ready) {
            if (FiCaptchaLoaderService.ready.getValue()) {
                return;
            }
        } else {
            FiCaptchaLoaderService.ready = new BehaviorSubject<any>(null);
            window['ng2recaptchaloaded'] = () => {
                FiCaptchaLoaderService.ready.next(grecaptcha);
            };
        }

        const script = document.createElement('script') as HTMLScriptElement;
        script.innerHTML = '';
        const langParam = this.language ? '&hl=' + this.language : '';
        script.src = `https://www.google.com/recaptcha/api.js?render=explicit&onload=ng2recaptchaloaded${langParam}`;
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);
    }
}
